<!-- SureScriptsRecordLocatorConsent.vue -->
<script setup lang="ts">
import { computed, watch } from 'vue';
import { DisplayStyle } from '../../../Enums/UiEnums';
import Checkbox from '../../../components/Inputs/Checkbox.vue';
import MessageText from '../../../components/Messages/MessageText.vue';
import SimpleFlexTable from '../../../components/Table/SimpleFlexTable.vue';
import SimpleFlexTableTitledRow from '../../../components/Table/SimpleFlexTableTitledRow.vue';
import { prettyDateTime } from '../../../lib/DateUtils';
import { FeatureType } from '../../../Enums/ChoiceEnums';
import FeatureConditional from '../../Conditionals/FeatureConditional.vue';
import MessageBadge from '../../../components/Messages/MessageBadge.vue';
import { IPatientSureScriptsInfo } from '../../../lib/Models/Patient/IPatientSureScriptsInfo';

    const props = defineProps<{
        sureScriptsInfo: IPatientSureScriptsInfo
    }>();

    enum ColIndex
    {
        Type,
        Consent
    }

    const emits = defineEmits(["update:patientData"]);
    function emitPatientData()
    {
        emits("update:patientData", props.sureScriptsInfo);
    }

    const syncNotYetAttempted = computed<boolean>(() => !props.sureScriptsInfo.lastSyncTimestampUTC);

    const showDateFields = computed<boolean>(() => !syncNotYetAttempted.value || undefined != props.sureScriptsInfo.startDateUTC || undefined != props.sureScriptsInfo.stopDateUTC);
</script>

<template>
    <FeatureConditional :feature="FeatureType.SureScriptsRecordLocator">
        <SimpleFlexTable :columnClasses='["simple-cell TitleColWidth", "simple-cell"]'>
            <SimpleFlexTableTitledRow>
                <template #Title>Consent Given</template>
                <Checkbox 
                    v-model="sureScriptsInfo.consentGiven" 
                    @update:modelValue="emitPatientData" />
            </SimpleFlexTableTitledRow>
    
            <SimpleFlexTableTitledRow v-if="showDateFields">
                <template #Title>Start Date</template>
                {{ prettyDateTime(sureScriptsInfo.startDateUTC) ?? "n/a" }}
            </SimpleFlexTableTitledRow>
    
            <SimpleFlexTableTitledRow v-if="showDateFields && sureScriptsInfo.stopDateUTC">
                <template #Title>Stop Date</template>
                {{ prettyDateTime(sureScriptsInfo.stopDateUTC) }}
            </SimpleFlexTableTitledRow>
    
            <SimpleFlexTableTitledRow>
                <template #Title>Sync Status</template>
    
                <MessageText :displayStyle="DisplayStyle.Success" v-if="true === sureScriptsInfo.syncSuccessful">
                    Loaded Successfully on {{ prettyDateTime(sureScriptsInfo.lastSyncTimestampUTC) }}
                </MessageText>
    
                <MessageText :displayStyle="DisplayStyle.Danger" v-if="false === sureScriptsInfo.syncSuccessful">
                    Failed on {{ prettyDateTime(sureScriptsInfo.lastSyncTimestampUTC) }}
                </MessageText>
    
                <MessageText :displayStyle="DisplayStyle.Danger" v-if="syncNotYetAttempted">
                    Sync not yet attempted
                </MessageText>
            </SimpleFlexTableTitledRow>
        </SimpleFlexTable>
        <template #featureDisabled="{feature}">
            <MessageBadge :displayStyle="DisplayStyle.Danger">
                Feature not enabled: {{ feature }}
            </MessageBadge>
        </template>
    </FeatureConditional>
</template>